import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { X } from "lucide-react";

export const EMPTY_FILTERS = { direction: "all", contact_id: "all", category: "all", assigned_to: "all", channel: "all", status: "all", date_from: "", date_to: "" };

export const filterParams = (f) => Object.fromEntries(Object.entries(f).filter(([, v]) => v && v !== "all"));

const Sel = ({ value, onChange, label, options, testid }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testid} className="h-9 w-auto min-w-[140px] bg-white"><SelectValue /></SelectTrigger>
    <SelectContent>
      <SelectItem value="all">{label}</SelectItem>
      {options.map((o) => <SelectItem key={o.value ?? o} value={o.value ?? o}>{o.label ?? o}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const InquiryFilterBar = ({ f, setF, settings }) => {
  const [people, setPeople] = useState([]);
  const [contacts, setContacts] = useState([]);
  useEffect(() => {
    api.get("/users/assignable?team=1").then((r) => setPeople(r.data)).catch(() => {});
    api.get("/contacts").then((r) => setContacts(r.data)).catch(() => {});
  }, []);
  const set = (k) => (v) => setF((x) => ({ ...x, [k]: v?.target ? v.target.value : v }));
  const dirty = JSON.stringify(f) !== JSON.stringify(EMPTY_FILTERS);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="inq-filter-bar">
      <Sel testid="ov-filter-direction" value={f.direction} onChange={set("direction")} label="All types" options={[{ value: "inbound", label: "Inbound" }, { value: "outbound", label: "Outbound" }]} />
      <Sel testid="ov-filter-contact" value={f.contact_id} onChange={set("contact_id")} label="All contacts" options={contacts.map((c) => ({ value: c.id, label: c.organisation ? `${c.name} · ${c.organisation}` : c.name }))} />
      <Sel testid="ov-filter-category" value={f.category} onChange={set("category")} label="All categories" options={settings?.categories || []} />
      <Sel testid="ov-filter-user" value={f.assigned_to} onChange={set("assigned_to")} label="All users" options={people.map((p) => ({ value: p.id, label: p.name }))} />
      <Sel testid="ov-filter-channel" value={f.channel} onChange={set("channel")} label="All channels" options={settings?.channels || []} />
      <Sel testid="ov-filter-status" value={f.status} onChange={set("status")} label="All statuses" options={(settings?.statuses || []).map((s) => ({ value: s.key, label: s.label }))} />
      <div className="flex items-center gap-1 text-xs text-slate-500">
        <Input data-testid="ov-filter-from" type="date" value={f.date_from} onChange={set("date_from")} className="h-9 w-[150px] bg-white" />
        <span>to</span>
        <Input data-testid="ov-filter-to" type="date" value={f.date_to} onChange={set("date_to")} className="h-9 w-[150px] bg-white" />
      </div>
      {dirty && <Button data-testid="ov-filter-clear" variant="ghost" size="sm" onClick={() => setF(EMPTY_FILTERS)} className="gap-1 text-slate-600"><X className="w-3.5 h-3.5" />Clear</Button>}
    </div>
  );
};
